import React, { type PropsWithChildren } from "react";

import { Container } from "@vega-core/components/Layout/Container";
import { ActionaryModal } from "@vega-core/components/Modals/ActionaryModal/ActionaryModal";
import { cnTwMerge } from "@vega-core/utils/cnTwMerge";

type Props = {
  open: boolean;
  setOpen?: (open: boolean) => void;
  variant?: "primary" | "secondary";
  skipCloseGuards?: boolean;
};

export const FullScreenModal = ({
  children,
  open,
  setOpen,
  variant = "primary",
  skipCloseGuards = false,
}: PropsWithChildren<Props>) => (
  <ActionaryModal
    allowFullScreenClose={Boolean(setOpen)}
    data-testid="full-screen-modal"
    fullScreen
    hideCloseButton
    open={open}
    setOpen={setOpen ?? (() => undefined)}
    skipCloseGuards={skipCloseGuards}
  >
    <Container
      className={cnTwMerge(
        "w-screen h-dvh overflow-y-auto",
        variant === "primary"
          ? "bg-background/primary"
          : "bg-background/secondary",
      )}
    >
      {children}
    </Container>
  </ActionaryModal>
);
